import Header from "../components/Header";
import {NavLink} from "react-router-dom";
import {Download, Plus} from "react-feather";
import Empty from "../components/Empty";
import {useEffect, useState} from "react";
import Data from "../../Data";
import ukMoment from "../../../../utils/ukTime";
import Meta from "../../../components/Meta";

const PAGE_SIZE = 20;

const UpcomingEvents = () => {

    const [pagedEvents, setPagedEvents] = useState([]);
    const [showPast, setShowPast] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(true);

    useEffect(async () => {
        setLoading(true);
        const result = await Data.fetchEventsPage({ scope: showPast ? 'past' : 'upcoming', page, pageSize: PAGE_SIZE });
        setPagedEvents(result.data.data);
        setTotalPages(result.data.totalPages);
        setLoading(false);
    }, [showPast, page]);

    const currentPage = page;

    return (
        <>
            <Meta title={"Upcoming Events"} />
            <Header heading={"Upcoming Events"} />
            <div className={"p-3 lg:p-6 grid grid-cols-1 gap-3 lg:gap-6 w-full"}>
                <div className={"flex items-center gap-2"}>
                    <button
                        onClick={() => { setShowPast(false); setPage(1); }}
                        aria-pressed={!showPast}
                        className={`px-2.5 py-1.5 rounded-md transition ${!showPast ? 'bg-primary text-white border-0' : 'bg-white text-textGrey border'}`}
                    >
                        Upcoming
                    </button>
                    <button
                        onClick={() => { setShowPast(true); setPage(1); }}
                        aria-pressed={showPast}
                        className={`px-2.5 py-1.5 rounded-md transition ${showPast ? 'bg-primary text-white border-0' : 'bg-white text-textGrey border'}`}
                    >
                        Past
                    </button>
                </div>
                {loading ?
                    <Empty>
                        <p>Loading...</p>
                    </Empty>
                    : pagedEvents.length === 0 ?
                    <Empty>
                        <p>{showPast ? 'No Past Events' : 'No Upcoming Events'}</p>
                    </Empty>
                    :

                    <>
                        <div className={"w-full overflow-x-auto"} style={{ WebkitOverflowScrolling: 'touch' }}>
                        <table
                            className={"min-w-[640px] w-full border-collapse outline outline-1 outline-gray-200 rounded-lg overflow-hidden drop-shadow-sm"}>
                            <thead className={"bg-gray-50"}>
                            <tr>
                                <th className={"text-left px-4 py-3 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>Date &amp; Time</th>
                                <th className={"text-left px-4 py-3 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>Experience</th>
                                <th className={"text-left px-4 py-3 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>Tickets</th>
                                <th className={"text-left px-4 py-3 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>Status</th>
                                <th className={"text-left px-4 py-3 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>Actions</th>
                            </tr>
                            </thead>
                            <tbody className={"bg-white"}>
                            {pagedEvents.map((event, index) => (
                                <tr className={"border-t"}>
                                    <td className={"px-4 py-2 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>{ukMoment(event.date).format('MMM Do YYYY, H:mm A')}</td>
                                    <td className={"px-4 py-2 lg:px-6 lg:py-4 truncate overflow-ellipsis"}><NavLink to={`/admin/experiences/${event.Experience._id}`}
                                                                         className={"underline"}>{event.Experience.name}</NavLink>
                                    </td>
                                    <td className={"px-4 py-2 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>{event.totalTickets === 0 ? '-' : `${event.totalTickets} ticket${event.totalTickets > 1 ? 's' : ''} (${event.bookings.length} booking${event.bookings.length > 1 ? 's' : ''})`}</td>
                                    <td className={"px-4 py-2 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>{event.ticketsRemaining > 0 ? `${event.ticketsRemaining} tickets remaining` : 'Sold Out'}</td>
                                    <td className={"px-4 py-2 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>
                                        <div className={"flex gap-2"}>
                                            <NavLink to={`/admin/upcoming-events/${event._id}`}
                                                     className={"bg-backgroundGrey px-2.5 py-1 rounded hover:opacity-80 transition"}>View</NavLink>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        </div>

                        <div className={"flex items-center gap-2 justify-center"}>
                            <button
                                onClick={() => setPage(p => Math.max(1, p - 1))}
                                disabled={currentPage <= 1}
                                className={`px-2.5 py-1.5 rounded-md border ${currentPage <= 1 ? 'opacity-50 cursor-not-allowed' : ''}`}
                            >
                                Prev
                            </button>
                            <span className={"text-textGrey text-sm"}>Page {currentPage} of {totalPages}</span>
                            <button
                                onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                                disabled={currentPage >= totalPages}
                                className={`px-2.5 py-1.5 rounded-md border ${currentPage >= totalPages ? 'opacity-50 cursor-not-allowed' : ''}`}
                            >
                                Next
                            </button>
                        </div>
                    </>
                }
            </div>
        </>
    )
}

export default UpcomingEvents